import { updateLastViewed } from '../api/projects';

// Track lastViewedAt for project
export const handleUpdateLastViewedProject = async (id: any) => {
  if (!id) return;
  const payload = {
    clientId: id,
    lastViewedAt: new Date(),
  };
  await updateLastViewed(payload);
};
